export const makeCloudinaryUpdatedImageUrl = (url: string) => {
  if (!url) return url;

  const rootParams = url.split('/');
  const firstParamIndex = rootParams.findIndex((param) => param === 'upload');
  let params = rootParams.slice(firstParamIndex + 1, rootParams.length);
  const paramsWithPath = [...params];
  params = params.filter(
    (param) =>
      param.startsWith('q_') ||
      param.startsWith('f_') ||
      param.startsWith('w_') ||
      param.startsWith('h_') ||
      param.startsWith('c_') ||
      param.startsWith('e_')
  );

  params = params.map((param) => {
    return [...param.split(',')].reverse().join(',');
  });

  const newUrl = `${rootParams.slice(0, firstParamIndex + 1).join('/')}/${[...params]
    .reverse()
    .join('/')}/${paramsWithPath.slice(params.length).join('/')}`;

  return newUrl;
};
